import { render, staticRenderFns } from "./Plantillas.vue?vue&type=template&id=486ca81a&scoped=true"
import script from "./Plantillas.vue?vue&type=script&lang=js"
export * from "./Plantillas.vue?vue&type=script&lang=js"
import style0 from "./Plantillas.vue?vue&type=style&index=0&id=486ca81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ca81a",
  null
  
)

export default component.exports